import { AjustedVariant } from "@modules/products/templates";
import { Field, FieldInputProps, FormikProps } from "formik";
import { ButtonsAmount } from "./buttons-amount";

type Props = {
  variants: AjustedVariant[],
  customVariants: AjustedVariant[]
}

const MediumGiftCardAmount = (props: Props) => {
  const { variants, customVariants } = props
  const name = "variant"
  return (
    <Field name={name}>
      {({
        field,
        form,
      }: {
        field: FieldInputProps<any>
        form: FormikProps<any>
      }) => {
        return (
          <div className="flex gap-2">
            <div className="text-right text-base text-black font-medium pt-1">
              Amount:
            </div>
            <div className="flex flex-wrap">
              <ButtonsAmount variants={variants} customVariants={customVariants} field={field} form={form} name={name}/>
            </div>
          </div>
        )
      }}
    </Field>
  )
}

export default MediumGiftCardAmount
